import { Component, Input } from '@angular/core';
import { LinkLabelComponent } from '../labels/link-label.component';
import { IconComponent } from '../labels/icon.component';
import { HelpItem } from '../../../models/api/core/configs/help-item';

@Component({
  selector: 'app-list',
  imports: [LinkLabelComponent, IconComponent],
  template: `
    <div class="tw-flex tw-flex-col tw-gap-1 tw-py-4">
      <ul
        role="list"
        class="tw-list-none tw-m-0 tw-p-0 tw-flex tw-flex-col tw-gap-1"
      >
        @for (item of items; track item.key) {
          <li role="listitem">
            <app-link-label
              [href]="item.url"
              target="_blank"
              [ariaLabel]="item.label"
              classes="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded tw-no-underline tw-font-bold hover:tw-underline tw-text-[var(--sed-link-color)] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-[var(--sed-sedgwick-green-color)]"
            >
              <div
                class="tw-rounded-full tw-size-7 tw-m-2 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center
              tw-bg-[var(--sed-purple-40-color)]"
                aria-hidden="true"
              >
                <app-icon
                  color="var(--sed-engaged-black-color)"
                  [name]="item.icon"
                />
              </div>
              <span>{{ item.label }}</span>
            </app-link-label>
          </li>
          <hr />
        }
      </ul>
    </div>
  `,
  styles: ``,
})
export class AppListComponent {
  @Input({ required: true })
  items: HelpItem[] = [];
}
